import persian from 'react-date-object/calendars/persian';
import gregorian from 'react-date-object/calendars/gregorian';
import persian_fa from 'react-date-object/locales/persian_fa';
import gregorian_en from 'react-date-object/locales/gregorian_en';

export const mapLanguageToCalendar = {
  ar: 'gregorian',
  fa: 'jalali',
};

export const mapCalendarToLocales = {
  gregorian: gregorian_en,
  jalali: persian_fa,
};

export const mapCalendarToCalendars = {
  gregorian: gregorian,
  jalali: persian,
};

export const mapCalendarToFormats = {
  gregorian: 'YYYY/MM/DD',
  jalali: 'jYYYY/jMM/jDD',
};

export const mapCalendarToWeekDays = {
  gregorian: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  jalali: ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'],
};
